<template>
  <div>
   
    
    <div class="login">
      <a-input addon-before="APPKey：" disabled = "true" default-value="" v-model="APPKey"/>
    </div>
    <div class="login" v-if="Exist">
      <a-input addon-before="APPKey：" disabled = "true" default-value="" v-model="SN"/>
    </div>
    <div class="login" >
      <a-button type='primary' @click="submit">回收</a-button>
    </div>
    <div class="login" >
      <a-button type='primary' @click="asign">锁定</a-button>
    </div>
    <div class="login" >
      <a-button type='primary' @click="release">使能</a-button>
    </div>
  </div>
  
</template>
<script>
export default {
  data(){
    
    return {
      user:"",
      SN:"",
      APPKey:this.$store.$axios.appkey,
      Exist:false
    }
  },
  created()
  {
    let sn = this.$store.state.qxaccount;
    
    if(sn.length > 0){
    let param = {
      appkey:SN,
    }
    let obj = this.$qs.stringify(param)
    this.$axios({
      method:'post',
      url:'/api/qxaccout/query',
      data: obj
    }).then((response) =>{    
            //这里使用了ES6的语法
      if(response.data.length>0){
      
        this.Exist = response.data["result"];
        this.SN = response.data["message"];
       console.log(response)       //请求成功返回的数据
      }
      else{
        
        console.log("not exist!")
      }
    }).catch((error) =>{
      
      console.log(error)       //请求失败返回的数据       
    })
    }
  },
    methods:{
        back(){
          this.$router.push('/home/terminallist')
        },
        submit (){
            let sn = this.$store.state.qxaccount;
    
    if(sn.length > 0){
    let param = {
      appkey:sn,
      state:1
    }
    let obj = this.$qs.stringify(param)
    this.$axios({
      method:'post',
      url:'/api/qxaccout/updatestate',
      data: obj
    }).then((response) =>{    
            //这里使用了ES6的语法
      if(response.data.length>0){
        this.Exist = true
        this.notExist = false
      
       console.log(response)       //请求成功返回的数据
      }
      else{
        this.Exist = false
        this.notExist = true
        console.log("not exist!")
      }
    }).catch((error) =>{
      
      console.log(error)       //请求失败返回的数据       
    })
    }

        },
        asign(){
          //TODO
          let sn = this.$store.state.qxaccount;
    
   
    let param = {
      appkey:sn,
      state:3
    }
    let obj = this.$qs.stringify(param)
    this.$axios({
      method:'post',
      url:'/api/qxaccout/updatestate',
      data: obj
    }).then((response) =>{    
            //这里使用了ES6的语法
      if(response.data.length>0){
        this.Exist = true
        this.notExist = false
      
       console.log(response)       //请求成功返回的数据
      }
      else{
        this.Exist = false
        this.notExist = true
        console.log("not exist!")
      }
    }).catch((error) =>{
      
      console.log(error)       //请求失败返回的数据       
    })
    
        },
        release(){
          //TODO
          let sn = this.$store.state.qxaccount;
    
    if(sn.length > 0){
    let param = {
      appkey:sn,
      state:1
    }
    let obj = this.$qs.stringify(param)
    this.$axios({
      method:'post',
      url:'/api/qxaccout/updatestate',
      data: obj
    }).then((response) =>{    
            //这里使用了ES6的语法
      if(response.data.length>0){
        this.Exist = true
        this.notExist = false
      
       console.log(response)       //请求成功返回的数据
      }
      else{
        this.Exist = false
        this.notExist = true
        console.log("not exist!")
      }
    }).catch((error) =>{
      
      console.log(error)       //请求失败返回的数据       
    })
    }
        }
    }
}
</script>
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.login {
  margin-top:20px;
  margin-left:auto;
  margin-right:auto;
  width:300px

}
</style>


// WEBPACK FOOTER //
// src/components/QxaccountDetail.vue